import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'odq-confidentiality-agreement',
    templateUrl: './confidentiality-agreement.component.html',
    styleUrls: ['./confidentiality-agreement.component.scss'],
    standalone: false
})
export class ConfidentialityAgreementComponent {

  constructor(public translate: TranslateService) { }

}
